export namespace SharedElement {
  export const BaseFill = 'base-fill';
  export type BaseFill = string;
  export const Accessory = 'is-accessory';
  export type Accessory = boolean;
}
